var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPrescriptionDefaultImage = function SvgPrescriptionDefaultImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 90,
    width: 90
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#cbcbcb",
    rx: 0,
    ry: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49.9,
    height: 36.4,
    x: 20.1,
    y: 26.8,
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "square",
    strokeMiterlimit: 30.3,
    strokeWidth: 4.9,
    rx: 3.4,
    ry: 3.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M55.3 34.4l-6.8 8.9-3.3-3.8-10 12.1-3.5-3.2-6.6 9.2H65v-7.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2,
    cy: 38.1,
    r: 5.1,
    fill: "#a0a0a0"
  })));
};
export default SvgPrescriptionDefaultImage;